import Select from 'react-select'
import Input from '../../../components/form-controls/Input'
import { Controller, useForm } from 'react-hook-form'
import InvalidFeedback from '../../../components/InvalidFeedback'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

function Step1Partial({ isValidForm, onChange }) {

    const{ t } = useTranslation();

    const defaultValues = {
        category: '',
        name: '',
        language: '',
    }

    const { control, register, watch, reset, setValue, getValues, formState: { errors, isValid } } = useForm({
        mode: 'onChange',
        defaultValues
    });


    const handleName = ({ target: { value } }) => {

        const newValue = value
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, "")
            .replace(/\s+/g, "_")
            .toLowerCase();

            
        setValue('name', newValue)
    }

    useEffect(() => {
        isValidForm(isValid)
        onChange(getValues())
    }, [isValid])


    return (
        <>
            <div className="row justify-content-center">
                <div className="col-8">
                    <div className="card ">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.category")}</h2>
                            <p className="small ">
                            {t("platform.channels.templates.category-p")}
                            </p>

                            <Controller
                                control={control}
                                name='category'
                                rules={{ required: true }}
                                render={
                                    ({
                                        field: { onChange, value },
                                        fieldState: { error }
                                    }) => {
                                        return (
                                            <ul className="list-group list-group-flush list-group-no-gutters">
                                                <li className={'list-group-item category py-5 px-3 ' + (value === 'MARKETING' ? 'selected': '' )} onClick={() => onChange('MARKETING')}> 
                                                    <div className="d-flex">
                                                        <div className="category-icon">
                                                            <i className="bi-megaphone-fill"></i>
                                                        </div>
                                                        <div className="ms-3">
                                                            <h4>{t("platform.channels.templates.marketing")}</h4>
                                                            <p className="mb-0">{t("platform.channels.templates.marketing-description")}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className={'list-group-item category py-5 px-3 ' + (value === 'UTILITY' ? 'selected': '')} onClick={() => onChange('UTILITY')}>
                                                    <div className="d-flex">
                                                        <div className="category-icon">
                                                            <i className="bi-bell-fill"></i>
                                                        </div>
                                                        <div className="ms-3">
                                                            <h4>{t("platform.channels.templates.services")}</h4>
                                                            <p className="mb-0">{t("platform.channels.templates.services-description")}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className={'list-group-item category py-5 px-3 ' + (value === 'AUTHENTICATION' ? 'selected': '')} onClick={() => onChange('AUTHENTICATION')}>
                                                    <div className="d-flex">
                                                        <div className="category-icon">
                                                            <i className="bi-key-fill"></i>
                                                        </div>
                                                        <div className="ms-3">
                                                            <h4>{t("platform.channels.templates.authentication")}</h4>
                                                            <p className="mb-0">{t("platform.channels.templates.authentication-description")}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        )
                                    }
                                }
                            />

                            
                        </div>
                    </div>
                    <hr />

                    <div className="card ">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.name-label")}</h2>
                            <p className="small ">
                            {t("platform.channels.templates.name-text")}
                            </p>

                            <div className="mb-3">
                                <Input
                                    errors={errors.name} {...register('name', { required: true, maxLength: { value: 512, message: '512' }, onChange: handleName })}
                                    currentLength={watch('name').length}
                                    maxLength={512}
                                />
                            </div>
                        </div>
                    </div>
                    <hr />

                    <div className="card">
                        <div className="card-body">
                            <h2 className="card-title h4">{t("platform.channels.templates.language-label")}</h2>
                            <p className="small ">
                            {t("platform.channels.templates.language-text")}
                            </p>

                            <div className="mb-3">
                                <Controller
                                    control={control}
                                    name='language'
                                    rules={{ required: true }}
                                    render={
                                        ({
                                            field: { onChange, value },
                                            fieldState: { error }
                                        }) => {
                                            return (
                                                <>
                                                    <Select
                                                        options={[
                                                            { value: 'es_MX', label: 'Español (MEX)' },
                                                            { value: 'en_US', label: 'Inglés (US)' },
                                                        ]}
                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                        classNamePrefix='form-select-custom'
                                                        placeholder={t("platform.channels.templates.language")}
                                                        onChange={(data: any) => onChange(data)}
                                                        value={value as any}
                                                    />
                                                    <InvalidFeedback error={error} />
                                                </>
                                            )
                                        }
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Step1Partial